import { render, staticRenderFns } from "./shaij.vue?vue&type=template&id=61316604&scoped=true&"
import script from "./shaij.vue?vue&type=script&lang=js&"
export * from "./shaij.vue?vue&type=script&lang=js&"
import style0 from "./shaij.vue?vue&type=style&index=0&id=61316604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61316604",
  null
  
)

export default component.exports